import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.5 13a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m4-5.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.25 14.25c-1.117 0-2.148.547-2.88 1.449-.73.897-1.12 2.086-1.12 3.301v2a.75.75 0 0 0 1.5 0v-2c0-.907.294-1.752.784-2.355.487-.6 1.11-.895 1.716-.895h6.5c.607 0 1.23.296 1.716.895.49.603.784 1.448.784 2.355v2a.75.75 0 0 0 1.5 0v-2c0-1.215-.39-2.404-1.12-3.301-.732-.902-1.763-1.449-2.88-1.449zM14.75 3a.75.75 0 0 1 .75-.75 5.25 5.25 0 1 1 0 10.5.75.75 0 0 1 0-1.5 3.75 3.75 0 1 0 0-7.5.75.75 0 0 1-.75-.75M18.188 14.404a.75.75 0 1 0-.375 1.452A3.25 3.25 0 0 1 20.25 19v2a.75.75 0 0 0 1.5 0v-2a4.75 4.75 0 0 0-3.562-4.596"
    }, null, -1)
  ])))
}
export default { render: render }